import { List, type ListProps } from 'antd';
import dayjs from 'dayjs';
import { ReactNode } from 'react';

import { Schemas } from '@api-client/generated/types';
import { DEFAULT_DATE_FORMAT } from '@constants';
import { getAddressLine } from '@utils';

import * as S from './styled';

type BobContact = Schemas.BobContact;

type ContactsSimpleListProps = {
  emptyText?: ReactNode;
  selectedId?: string | null;
  dataSource?: Schemas.BobContact[];
  onSelect: (contact: BobContact) => void;
} & ListProps<BobContact>;

const ContactsSimpleList = ({
  emptyText,
  selectedId,
  dataSource,
  onSelect,
  ...props
}: ContactsSimpleListProps) => (
  <List
    dataSource={dataSource}
    renderItem={(item) => (
      <S.Contact
        gap={4}
        selected={selectedId === item.id}
        onClick={() => onSelect(item)}
        vertical
      >
        <S.ContactName>{item.name}</S.ContactName>
        <div>
          ID: {item.bobId ? <S.Reference>{item.bobId}</S.Reference> : '-'}
        </div>
        <div>VAT ID: {item.vatId || '-'}</div>
        <div>{getAddressLine(item.address)}</div>
        <S.SyncBadge synced={Boolean(item.bobSyncedAt)}>
          {item.bobSyncedAt
            ? `In BOB50 since ${dayjs(item.bobSyncedAt).format(DEFAULT_DATE_FORMAT)}`
            : 'Pending sync'}
        </S.SyncBadge>
      </S.Contact>
    )}
    locale={{
      emptyText: emptyText ? <S.Empty>{emptyText}</S.Empty> : <div />,
    }}
    {...props}
  />
);

export default ContactsSimpleList;
